import React from "react";

export const ArchiveBlock: React.FC<any> = () => {
  return null;
};
